var map = {
	"./flag_en_icon.png": 221,
	"./flag_th_icon.png": 222
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 632;



//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/flag_.*_icon\.png$
// module id = 632
// module chunks = 1